import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.SAVE_PREFERRED_COMMUNICATIONS_REQUEST:
      return {
        ...state,
        data: null,
        isProgress: true,
      };
    case homeConstants.SAVE_PREFERRED_COMMUNICATIONS_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.SAVE_PREFERRED_COMMUNICATIONS_FAILURE:
      return {
        data: null,

        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
